var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.authorized === true)?_c('button',{staticClass:"button is-success"},[_vm._v("\n    Sim\n  ")]):_c('b-dropdown',{attrs:{"triggers":['hover'],"aria-role":"list","position":"is-bottom-left"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('button',{staticClass:"button",class:{
          'is-danger': _vm.authorized === false || (_vm.error && _vm.error.code),
          'is-light': _vm.authorized === undefined
        },attrs:{"slot":"trigger"},slot:"trigger"},[_vm._v("\n        "+_vm._s(_vm.authorized === false || (_vm.error && _vm.error.code)
            ? _vm.$t("common.no")
            : _vm.authorized === undefined
            ? _vm.$t("accesses.withoutInfo")
            : "-")+"\n      ")])]},proxy:true}])},[(!_vm.authorized && _vm.error)?_c('b-dropdown-item',{attrs:{"aria-role":"listitem"}},[_vm._v("\n      "+_vm._s(_vm.translateAccessErrorStatus(_vm.error.code))+"\n    ")]):(
        _vm.device.provider === 'condlink' &&
          _vm.accessType === 'staticStorePresentedQRCode' &&
          !_vm.error
      )?_c('b-dropdown-item',{attrs:{"aria-role":"listitem"},domProps:{"innerHTML":_vm._s(_vm.$t('accesses.internetProblemMayHaveOccuried'))}}):(
        _vm.device.provider === 'condlink' &&
          _vm.accessType === 'dynamicAppPresentedQRCode' &&
          !_vm.error
      )?_c('b-dropdown-item',{attrs:{"aria-role":"listitem"},domProps:{"innerHTML":_vm._s(_vm.$t('accesses.clientMayNotHaveTriedToUseQRCode'))}}):(
        _vm.device.provider === 'condlink' &&
          _vm.accessType === 'faceRecognition' &&
          !_vm.error
      )?_c('b-dropdown-item',{attrs:{"aria-role":"listitem"},domProps:{"innerHTML":_vm._s(_vm.$t('accesses.internetProblemMayHaveOccuried'))}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }